import { useFeatureFlag as useFeatureFlagAF, useSettings as useSettingsAF } from '@atlassian/teams';

/**
 * @private
 * @deprecated Migration is complete & AF components & always enabled
 */
export const useIsAtlassianTeamsEnabled = () => {
  return true;
};
export const useFeatureFlag = flagName => {
  return useFeatureFlagAF(flagName);
};
export const useSettings = () => {
  return useSettingsAF();
};